import { Component, OnInit, AfterContentInit, AfterViewChecked, ViewEncapsulation, Inject, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { CmsStudioService } from '../cms-studio.service';
import { Cms } from "../models/cms.model";
import { CmsViewDirectiveService, CmsViewDirectiveInterface } from '../cmsdirectives/cmsviewdirective.service';
import { CmsViewDirectiveComponent } from '../cmsdirectives/cmsviewdirective.component';
declare var jQuery;
declare var $;

@Component({
  selector: 'app-cms-studio-preview',
  templateUrl: './cmspreview.component.html',
  styleUrls: ['../cmsstudio.component.css'],
  providers: [CmsViewDirectiveComponent]
  //encapsulation: ViewEncapsulation.None,
})

export class CmspreviewComponent implements OnInit, CmsViewDirectiveInterface {
  title: string = "CMS - View";
  setFullWindow = true;
  subWidth: string;
  cms: Cms;
  cmsList: Array<Cms>;
  keysCms: string;
  finalKey: Array<any> = [];
  finalValue: Array<any> = [];
  slideToggle: string;

  viewNavIndex: number;
  viewChildId = null;

  constructor(
    private router: Router,
    private ngProgress: NgProgress,
    private activeRouter: ActivatedRoute,
    private cmsStudioService: CmsStudioService,
    @Inject(CmsViewDirectiveService) private service, @Inject(ViewContainerRef)
    private viewContainerRef
  ) { }

  ngOnInit() {
    console.log(this.activeRouter);
    this.activeRouter.params.subscribe(params => {
      console.log(params);
      if (params["selector"] && params["selectorValue"]) {
        if (params["selector"] == "categorypath") {
          this.cmsStudioService.getCmsForCategoryPath(params["selectorValue"])
            .subscribe(res => {
              console.log(res);
              this.cms = res.cms;
            });
        }
        if (params["selector"] == "tag") {
          this.cmsStudioService.getCmsForTag(params["selectorValue"])
            .subscribe(res => {
              console.log(res);
              this.cmsList = res.cmsList;
              this.cms = this.cmsList[0];
            });
        }
      }
    });

    this.toggleSlide('close');
  }

  getBackgroundColor(i) {
    var ret = '#FBFBFB';
    switch (i) {
      case 0:
        ret = '#FBFBFB';
        break;
      case 1:
        ret = '#F7F7F7';
        break;
      case 2:
        ret = '#F4F4F4';
        break;
      case 3:
        ret = '#EEEEEE';
        break;
    }
    return ret;
  }

  viewNavigation(i) {
    this.viewNavIndex = i
    $('.page-contents').animate({ scrollLeft: $('#viewCmsStuiod').width() + 250 }, 400);
  }

  toggleSlide(action) {
    /*if (action == 'close')
      $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);
    if (action == 'open')
      $('.page-contents').animate({ scrollRight: $('#levelOne').width() }, 400);*/
  }

  openViewStudio() {
    $('.page-contents').animate({ scrollLeft: -$('#cmsView').width() }, 400);
    jQuery("app-cms-view-directive").hide();
  }

  closeView() {
    $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/cms/view');
  }

  clickEvent(e) {
    console.log(e.target.dataset.id);
    if (e.target.dataset.class = 'cmsTemplate' && this.viewChildId != e.target.dataset.id) {
      jQuery("app-cms-view-directive").hide();
      this.service.setRootViewContainerRef(this.viewContainerRef);
      this.service.addDynamicComponent(e.target.dataset.id);
      this.viewChildId = e.target.dataset.id;
      $('.page-contents').animate({ scrollLeft: $('app-cms-studio-preview').width() + 250 }, 400);
    }
  }
}